<div class="exception-body error">
    <img src="assets/layout/images/logo-white.svg" alt="SmartBox" class="logo">

    <div class="exception-content">
        <div class="exception-title">ERROR</div>
        <div class="exception-detail">Something went wrong.</div>
        <a [routerLink]="['/']">Go to Dashboard</a>
    </div>
</div>
